<template>
  <div :class="$style.root">
    {{ currentOption.text }}
    <span :class="$style.arrow" />
    <select
      :class="$style.select"
      @change="handleChange($event.target.value)"
    >
      <option
        v-for="option in options"
        :key="option.value"
        :value="option.value"
        :selected="currentOption.value === option.value"
      >
        {{ option.text }}
      </option>
    </select>
  </div>
</template>

<script>
import {
  arrayOf,
  number,
  string,
  shape,
  oneOfType,
} from 'vue-types';

const optionType = shape({
  text: string(),
  value: oneOfType([string(), number()]),
});

export default {
  props: {
    options: arrayOf(optionType).isRequired,
    currentOption: optionType.isRequired,
  },

  emits: ['change'],

  methods: {
    handleChange(value) {
      this.$emit(
        'change',
        {
          ...this.options.find(
            (option) => String(option.value) === value,
          ),
        },
      );
    },
  },
};
</script>

<style lang="scss" module>
@import "~@/styles/variables.scss";

.root {
  position: relative;
  display: inline-flex;
  color: $color-blue;
  align-items: center;
}

.select {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border: none;
  appearance: none;
  background-color: transparent;
  padding: 0;
  cursor: pointer;
  opacity: 0;

  &:focus {
    outline: none;
  }
}

.arrow {
  width: 7px;
  height: 7px;
  border-right: 2px solid $color-blue;
  border-bottom: 2px solid $color-blue;
  transform: rotate(45deg);
  display: inline-block;
  margin-left: 4px;
}
</style>
